<template>
  <div>
    <div class="flex justify-end">
      <el-button v-if="!isAddOnOrder && !isForMarkupDialog && !onlyEditMerch" class="clear-all-btn" @click="clearAll">
        {{ $t("OrderPage[\"Clear All\"]") }}
      </el-button>
    </div>
    <div v-if="isAddOnOrder.length > 0" :class="isForMarkupDialog ? '' : 'px-3 pb-5'">
      <div v-if="!isAddOnOrder || showAddOnOrderedItem">
        <template v-if="showItemTypeGroup">
          <div v-if="getVibrantItems(addOnselectedItemList.addOnSelectedItemList).length > 0" class="item-type-group mt-1">
            <div class="item-type-group-title">Vibrant Product</div>
            <OrderedItem
              class="mt-1 background-color"
              v-for="item in getVibrantItems(addOnselectedItemList.addOnSelectedItemList)"
              :key="item.id"
              :item="item"
              :test-name-list="getTestNameList(item).nameList"
              :test-price-total="getTestNameList(item).totalPrice"
              :is-for-markup-dialog="isForMarkupDialog"
              :is-show-edit-markup="false"
              :show-clear-button="showClearButtons"
            />
          </div>
          <div v-if="getProgramItems(addOnselectedItemList.addOnSelectedItemList).length > 0" class="item-type-group mt-1">
            <div class="item-type-group-title">Program</div>
            <OrderedItem
              class="mt-1 background-color"
              v-for="item in getProgramItems(addOnselectedItemList.addOnSelectedItemList)"
              :key="item.id"
              :item="item"
              :test-name-list="getTestNameList(item).nameList"
              :test-price-total="getTestNameList(item).totalPrice"
              :is-for-markup-dialog="isForMarkupDialog"
              :is-show-edit-markup="false"
              :show-clear-button="showClearButtons"
            />
          </div>
        </template>
        <template v-else>
          <OrderedItem
            class="mt-1 background-color"
            v-for="item in addOnselectedItemList.addOnSelectedItemList"
            :key="item.id"
            :item="item"
            :test-name-list="getTestNameList(item).nameList"
            :test-price-total="getTestNameList(item).totalPrice"
            :is-for-markup-dialog="isForMarkupDialog"
            :is-show-edit-markup="false"
            :show-clear-button="showClearButtons"
          />
        </template>
      </div>
      <button 
        class="flex items-center mx-auto gap-1 add_on_unfold_btn mt-5" 
        :class="addOnselectedItemList.selectedItemOrderList.length > 0 ? 'mb-5' : ''"
        v-if="isAddOnOrder" 
        @click="toggleAddOnOrderedItemsVisibility"
        >
        {{ $t("OrderPage[\"{ this.addOnCollapseExpandToggleText } Tests in the Original Order\"]", { addOnCollapseExpandToggleText: addOnCollapseExpandToggleTextMap[this.addOnCollapseExpandToggleText] }) }}
        <span>
          <img src="@/assets/orderTest/unfold_more_24px.svg">
        </span>
      </button>
      <template v-if="showItemTypeGroup">
        <div v-if="getVibrantItems(addOnselectedItemList.selectedItemOrderList).length > 0" class="item-type-group mt-1">
          <div class="item-type-group-title">Vibrant Product</div>
          <OrderedItem
            class="mt-1 background-color"
            v-for="item in getVibrantItems(addOnselectedItemList.selectedItemOrderList)"
            :key="item.id"
            :item="item"
            :test-name-list="getTestNameList(item).nameList"
            :test-price-total="getTestNameList(item).totalPrice"
            :is-for-markup-dialog="isForMarkupDialog"
            :test-markup-price-list="getTestNameList(item).markupPriceList"
            :show-clear-button="showClearButtons"
            @saveMarkup="updateItemMarkup(item, $event)"
          />
        </div>
        <div v-if="getProgramItems(addOnselectedItemList.selectedItemOrderList).length > 0" class="item-type-group mt-1">
          <div class="item-type-group-title">Program</div>
          <OrderedItem
            class="mt-1 background-color"
            v-for="item in getProgramItems(addOnselectedItemList.selectedItemOrderList)"
            :key="item.id"
            :item="item"
            :test-name-list="getTestNameList(item).nameList"
            :test-price-total="getTestNameList(item).totalPrice"
            :is-for-markup-dialog="isForMarkupDialog"
            :test-markup-price-list="getTestNameList(item).markupPriceList"
            :show-clear-button="showClearButtons"
            @saveMarkup="updateItemMarkup(item, $event)"
          />
        </div>
        <div v-if="selectedMerchList.length > 0" class="item-type-group mt-1">
          <div class="item-type-group-title">Practice Product</div>
          <MerchItemInEdit
            class="mt-1"
            v-for="item in selectedMerchList"
            :key="item.id"
            :item="item"
          />
        </div>
      </template>
      <template v-else>
        <OrderedItem
          class="mt-1 background-color"
          v-for="item in addOnselectedItemList.selectedItemOrderList"
          :key="item.id"
          :item="item"
          :test-name-list="getTestNameList(item).nameList"
          :test-price-total="getTestNameList(item).totalPrice"
          :is-for-markup-dialog="isForMarkupDialog"
          :test-markup-price-list="getTestNameList(item).markupPriceList"
          :show-clear-button="showClearButtons"
          @saveMarkup="updateItemMarkup(item, $event)"
        />
        <MerchItemInEdit
          class="mt-1"
          v-for="item in selectedMerchList"
          :key="item.id"
          :item="item"
        />
      </template>
    </div>
    <div v-else :class="isForMarkupDialog ? '' : 'px-3 pb-5'">
      <EditOrderItemCard
        class="mt-1 background-color"
        v-for="item in editOrderItemList"
        :key="item.item_id"
        :item="item"
      />
      <template v-if="showItemTypeGroup">
        <div v-if="getVibrantItems(selectedItemList).length > 0" class="item-type-group mt-1">
          <div class="item-type-group-title">Vibrant Product</div>
          <OrderedItem
            class="mt-1 background-color"
            v-for="item in getVibrantItems(selectedItemList)"
            :key="item.id"
            :item="item"
            :test-name-list="getTestNameList(item).nameList"
            :test-price-total="getTestNameList(item).totalPrice"
            :is-for-markup-dialog="isForMarkupDialog"
            :test-markup-price-list="getTestNameList(item).markupPriceList"
            :show-clear-button="showClearButtons"
            @saveMarkup="updateItemMarkup(item, $event)"
          />
        </div>
        <div v-if="!isForMarkupDialog && selectedMerchList.length > 0" class="item-type-group mt-1">
          <div class="item-type-group-title">Practice Product</div>
          <div v-if="!editOrderSampleId">
            <OrderedMerchItem
              class="mt-1 background-color"
              v-for="item in selectedMerchList"
              :key="item.id"
              :item="item"
              :show-clear-button="showClearButtons"
            />
          </div>
          <div v-else>
            <MerchItemInEdit
              class="mt-1"
              v-for="item in selectedMerchList"
              :key="item.id"
              :item="item"
            />
          </div>
        </div>
        <div v-if="getProgramItems(selectedItemList).length > 0" class="item-type-group mt-1">
          <div class="item-type-group-title">Program</div>
          <OrderedItem
            class="mt-1 background-color"
            v-for="item in getProgramItems(selectedItemList)"
            :key="item.id"
            :item="item"
            :test-name-list="getTestNameList(item).nameList"
            :test-price-total="getTestNameList(item).totalPrice"
            :is-for-markup-dialog="isForMarkupDialog"
            :test-markup-price-list="getTestNameList(item).markupPriceList"
            :show-clear-button="showClearButtons"
            @saveMarkup="updateItemMarkup(item, $event)"
          />
        </div>
      </template>
      <template v-else>
        <OrderedItem
          class="mt-1 background-color"
          v-for="item in selectedItemList"
          :key="item.id"
          :item="item"
          :test-name-list="getTestNameList(item).nameList"
          :test-price-total="getTestNameList(item).totalPrice"
          :is-for-markup-dialog="isForMarkupDialog"
          :test-markup-price-list="getTestNameList(item).markupPriceList"
          :show-clear-button="showClearButtons"
          @saveMarkup="updateItemMarkup(item, $event)"
        />
        <div v-if="!isForMarkupDialog">
          <div v-if="!editOrderSampleId">
            <OrderedMerchItem
              class="mt-1 background-color"
              v-for="item in selectedMerchList" 
              :key="item.id" 
              :item="item"
              :show-clear-button="showClearButtons"
            />
          </div>
          <div v-else>
            <MerchItemInEdit
              class="mt-1"
              v-for="item in selectedMerchList" 
              :key="item.id" 
              :item="item" 
            />
          </div>
        </div>
      </template>
      <!-- <div v-if="familyDiscountEligible">
        <FamilyDiscountOrderInfo v-if="familyDiscountOrders.length > 0" class="mt-2.5" />
        <FamilyDiscountEligibleAlert @addFamilyMember="addFamilyMember" />
        <FamilyDiscountDialogs 
          :is-show-dialog="showChooseFamilyMemberDialog" 
          @closeFamilyMemberDialog="showChooseFamilyMemberDialog = false" 
          @openChooseFamilyMemberDialog="showChooseFamilyMemberDialog = true"
        />
      </div> -->
    </div>
  </div>
</template>
  
  <script>
  import EditOrderItemCard from "@/views/va-orderTest/components/EditOrderItemCard.vue";
  import OrderedItem from "../../../components/OrderedItem.vue";
  import OrderedMerchItem from "../../../components/OrderedMerchItem.vue";
  import MerchItemInEdit from "@/views/va-orderTest/components/MerchItemInEditOrder.vue";
  import FamilyDiscountEligibleAlert from "@/views/va-orderTest/family-discount/FamilyDiscountEligibleAlert.vue";
  import FamilyDiscountDialogs from "@/views/va-orderTest/family-discount/family-discount-dialogs/index.vue";
  import FamilyDiscountOrderInfo from "@/views/va-orderTest/family-discount/family-discount-order-info/index.vue";
  import { mapState, mapGetters } from "vuex";
  import { findInAppPromo, findExclusiveAddOns, getTestNameList, removeItemInSelectedItemList } from "./index.js";
  import { updateSelectedItemsRecommendMarkup } from "./updateRecommendMarkup.js"
  import { handleException, handleBloodSalivaAddonException } from "@/utils/va-order-test/testAndPanelSelection/handleException.js";
  import { handleDuplicateTests } from "@/utils/va-order-test/testAndPanelSelection/handleDuplicateTests.js";
  import { handleBestDealSuggestion } from "@/utils/va-order-test/bestDealSuggestion";
  import { 
    getPlanAndSaveItems, 
    getPlanAndSaveEligibleItems, 
    getPlanAndSavePrice 
  } from "@/utils/va-order-test/plan-and-save/index.js";
  import { removeItem } from "@/utils/va-order-test/testAndPanelSelection";
  import { removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection";
  import { updateItemMarkup } from "@/store/modules/va-order-test/helpers/markup.js"
  import { handleEditOrderCoupon } from "@/store/modules/va-order-test/helpers/orderDraft";
  import { applyConditionalDiscounts } from "@/utils/va-order-test/index.js";
  import _ from "lodash";

  export default {
    components: {
      EditOrderItemCard,
      OrderedItem,
      OrderedMerchItem,
      MerchItemInEdit,
      // FamilyDiscountEligibleAlert,
      // FamilyDiscountDialogs,
      // FamilyDiscountOrderInfo
    },
    props: {
      itemList: {
        type: Array,
        default: () => []
      },
      isForMarkupDialog: {
        type: Boolean,
        default: false,
      },
      showClearButtons: {
        type: Boolean,
        default: false,
      },
      showItemTypeGroup: {
        type: Boolean,
        default: false,
      }
    },
    emits: ["handleInAppPromo", "handleExclusiveAddOns"],
    data() {
      return {
        showAddOnOrderedItem: false,
        addOnCollapseExpandToggleText: "Show",
        showChooseFamilyMemberDialog: false,
      }
    },
  
    computed: {
      ...mapState(["language", "currency"]),
      ...mapState("orderTest", ["isDbsVersion", "discountMap", "isAddOnOrder", "addOnFixedVaVwTest"]),
      ...mapState("orderTest/tests", ["selectedTestIdList"]),
      ...mapState("orderTest/promotions", ["seasonalPromotionList", "vibrantHighlightList"]),
      ...mapState("orderTest/order", ["plannedOrderList", "planAndSaveDiscountPercent", "isPatientValidFollowUpOrder", "editOrderSampleId", "promoCode"]),
      ...mapState("orderTest/orderDraft", ["editOrderItemList", "orderDraft"]),
      ...mapState("orderTest/favorites", ["shortcutList"]),
      ...mapState("orderTest/user", ["userInfo"]),
      // Family Bundle - State (UI hidden, keeping for potential future use)
      ...mapState("orderTest/familyDiscount", ["familyDiscountOrders"]),
      ...mapGetters("orderTest", [
        "orderTestSupportObj",
        "selectedVwTestPrice",
        "selectedItemsPrice",
        "addOnselectedItemList",
        "selectedItemList"
      ]),
      ...mapGetters("orderTest/favorites", ["itemsInSelectedShortcuts"]),
      ...mapGetters("orderTest/tests", ["testList", "vwTestList"]),
      ...mapGetters("orderTest/panels", ["bundleList"]),
      ...mapGetters("orderTest/order", ["orderItemList"]),
      ...mapGetters("orderTest/merchandise", ["selectedMerchList"]),
      // Family Bundle - Getters (UI hidden, keeping for potential future use)
      ...mapGetters("orderTest/familyDiscount", ["familyDiscountEligible"]),
  
      addOnCollapseExpandToggleTextMap() {
        return {
          "Show": this.$t("OrderPage[\"Show\"]"),
          "Expand": this.$t("OrderPage[\"Expand\"]"),
          "Collapse": this.$t("OrderPage[\"Collapse\"]")
        };
      },

      // total price for all items which best deal applicable
      bestDealApplicateItemsPrice() {
        let price = 0;
        price = this.orderItemList
          .filter(item => !["customPanel", "shortcut"].includes(item.category))
          .reduce((acc, item) => {
            return acc + item.price;
          }, 0);
        return price;
      },
      isAnyThreeDBSPromoStart() {
        if(this.seasonalPromotionList.find(x => x.discountName === "5 for $1000 Bundle")) {
          return true
        }
        return false
      },
      onlyEditMerch() {
        if (!this.editOrderSampleId) {
          return false;
        }
        return this.editOrderItemList.length === 0;
      },
    },
  
    watch: {
      orderItemList(newValue, oldValue) {
        // find best deal panel and test combination (exclude for custom panel)
        this.findBestDeal(newValue, oldValue);
        // remove tests that were already selected in shortcut if any
        this.removeSelectedTestInShortcut();
        // remove tests that were already be selected in edit order if any
        // to avoid duplicate charge
        this.removeSelectedTestInEditOrder();
        // remove regenere and nutriproz if they are not eligible to select
        this.removeInEligibleSkincareAndNutriProzTests();
        // update selected items's recommend markup price if any
        updateSelectedItemsRecommendMarkup(this.orderTestSupportObj);
        if (!this.isAddOnOrder && !this.editOrderSampleId) {
          // find in-app promo when not add-on order and not edit order
          let inAppPromos = findInAppPromo(this.orderTestSupportObj, this.discountMap, this.isDbsVersion);
          this.$emit("handleInAppPromo", inAppPromos);
          // find exclusive add-ons
          let exclusiveAddOns = findExclusiveAddOns(this.orderTestSupportObj, this.discountMap, this.isDbsVersion);
          this.$emit("handleExclusiveAddOns", exclusiveAddOns);
        }
        if (this.editOrderSampleId && oldValue.length > 0) {
          let currency = this.currency ? this.currency.name.toLowerCase() : "usd";
          this.debounceHandleEditOrderCoupon(this.editOrderSampleId, currency, this.promoCode, newValue, this.orderTestSupportObj);
        }
      },
      isPatientValidFollowUpOrder() {
        this.removeInEligibleSkincareAndNutriProzTests();
      }
    },

    created() {
      this.debounceHandleEditOrderCoupon = _.debounce(handleEditOrderCoupon, 1000);
    },
    methods: {
      getProgramItems(itemList = []) {
        return (itemList || []).filter(item => item && item.category === "program");
      },
      getVibrantItems(itemList = []) {
        return (itemList || []).filter(item => item && item.category !== "program");
      },
      clearAll() {
        this.$store.dispatch("orderTest/clearSelectedItemList");
        // clear all edit order original selected items
        this.$store.dispatch("orderTest/orderDraft/setEditOrderItemList", []);
        this.$store.dispatch("orderTest/program/clearSelectedPrograms");
        if (!this.editOrderSampleId) {
          this.$store.dispatch("orderTest/merchandise/clearAllSelectedMerch");
        }
        // Reset fees to ensure subtotal shows 0
        this.$store.dispatch("orderTest/order/setConciergeFee", { amount: 0, isUse: false });
        this.$store.dispatch("orderTest/order/setConsultationFee", { amount: 0, isUse: false, name: "Consultation Fee" });
        this.$store.dispatch("orderTest/order/setPromoCode", "");
        this.$store.dispatch("orderTest/order/setPromoDiscount", 0);
      },

      getTestNameList(item) {
        return getTestNameList(item, this.orderTestSupportObj, this.language);
      },
  
      findBestDeal(newValue, oldValue) {
        // console.log("oldValue", oldValue.map(item => item.id));
        // console.log("newValue", newValue.map(item => item.id));
        let isSame = newValue.length === oldValue.length 
          && newValue.every(newV => oldValue.find(oldV => oldV.id ? oldV.id === newV.id : oldV.bundleId === newV.bundleId));
        if (isSame) {
          return;
        }
        const itemList = this.selectedItemList.filter(i => i.category !== "shortcut").concat(this.itemsInSelectedShortcuts || []);
        applyConditionalDiscounts(this.testList, "isSelect", itemList);
        // handle exceptions
        handleException("isSelect", "isNotAllowedSelect", this.orderTestSupportObj);
        // handle special rule for blood/saliva addons
        handleBloodSalivaAddonException("isSelect", "isNotAllowedSelect", this.orderTestSupportObj);
        // console.log("after exception", [...this.selectedTestIdList])
        handleDuplicateTests("isSelect", this.orderTestSupportObj);
        // console.log("after duplicate tests", [...this.selectedTestIdList])
        this.handleVibrantHighlightSelection();
        if (newValue.length === 0) {
          return;
        }
        // this.$emit("handleIsSuggestionLoading", true);
        let isBundleReplaceTriggered = handleBestDealSuggestion("isSelect", this.bestDealApplicateItemsPrice, this.orderTestSupportObj, this.discountMap, this.isDbsVersion);
        if (isBundleReplaceTriggered) {
          this.$store.dispatch("orderTest/setBundleReplaceTriggered");
        }
        // console.log("after deal suggestion", [...this.selectedTestIdList])
      },
      updatePlannedOrders() {
        if (this.itemList.length === 0) {
          this.$store.dispatch("orderTest/order/setPlannedOrderList", []);
          return;
        }
        this.plannedOrderList.forEach((order, index) => {
          let updatedPlannedOrder = { ...order };
          let orderedItems = getPlanAndSaveItems(this.itemList, this.testList, this.bundleList);
          let discountEligibleItems = getPlanAndSaveEligibleItems(this.isDbsVersion, orderedItems, this.testList);
          let { originalPrice, discountPrice } = getPlanAndSavePrice(orderedItems, discountEligibleItems, this.planAndSaveDiscountPercent, this.vwTestList);
          updatedPlannedOrder.orderedItems = orderedItems;
          updatedPlannedOrder.discountEligibleItems = discountEligibleItems;
          updatedPlannedOrder.originalPrice = originalPrice;
          updatedPlannedOrder.discountPrice = discountPrice;
          this.$store.dispatch("orderTest/order/updatePlannedOrder", { index, updatedPlannedOrder });
        })
      },
      toggleAddOnOrderedItemsVisibility() {
        // Toggle the visibility of the addOnSelectedItemList
        this.showAddOnOrderedItem = !this.showAddOnOrderedItem;
        this.addOnCollapseExpandToggleText = this.showAddOnOrderedItem ? "Collapse" : "Expand";
      },
      removeSelectedTestInShortcut() {
        let { shortcutList, selectedShortcutIdList, selectedTestIdList } = this.orderTestSupportObj;
        let selectedShortcut = shortcutList.filter(shortcut => selectedShortcutIdList.includes(shortcut.id));
        selectedShortcut.forEach(shortcut => {
          shortcut.testIdList.forEach(testId => {
            removeItem(testId, selectedTestIdList);
          });
        });
      },
      // remove selected test that was already selected to edit order
      removeSelectedTestInEditOrder() {
        let { editOrderItemList, selectedTestIdList } = this.orderTestSupportObj;
        let testIdsInEditOrderItems = editOrderItemList
          .filter(item => ["va", "vw"].includes(item.category))
          .map(item => item.item_id);
        this.itemList.filter(item => ["va","vw"].includes(item.category))
          .forEach(item => {
            if (item.id < 0) {
              let testIds = item.packageTests.map(t => t.id);
              if (testIds.every(id => testIdsInEditOrderItems.includes(id))) {
                removeItem(item.id, selectedTestIdList);
              }
            } else {
              if (testIdsInEditOrderItems.includes(item.id)) {
                removeItem(item.id, selectedTestIdList);
              }
            }
        });
      },
      removeInEligibleSkincareAndNutriProzTests() {
        // for add on page, skip checking skincare and nutriProz followups if they were in the original order
        if(this.isAddOnOrder) {
          let addOnFixedVaVwTestKeys = Array.from(this.addOnFixedVaVwTest.keys())
          let addOnFixedVaVwTestValues = Array.from(this.addOnFixedVaVwTest.values())
          
          if(addOnFixedVaVwTestKeys.concat(addOnFixedVaVwTestValues).some(x => [731,725, 726].includes(x))) {
            return 
          }
        }
        let { SKINCARE, NUTRIPROZ_MAINTENANCE, NUTRIPROZ_REFILL } = this.isPatientValidFollowUpOrder;
        if (SKINCARE) {
          removeSelectedTest(731, "isSelect", this.orderTestSupportObj);
        }
        if (NUTRIPROZ_MAINTENANCE || NUTRIPROZ_REFILL) {
          [725, 726].forEach(id => {
            removeSelectedTest(id, "isSelect", this.orderTestSupportObj);
          });
        }
      },
      updateItemMarkup(item, params) {
        updateItemMarkup(item, params, this.orderTestSupportObj)
      },
      handleVibrantHighlightSelection() {
        // if there is no test selected, de-select all highlights
        this.vibrantHighlightList.forEach(highlight => {
          let tests = this.testList.filter(test => highlight.testIdList.includes(test.id));
          // special case for total toxin highlight(id: 3):
          // using total toxin descendant tests to check instead of its bundle
          let bundles = highlight.id === 3 
            ? this.testList.filter(test => [719, 196, 181].includes(test.id))
            : this.bundleList.filter(bundle => highlight.bundleIdList.includes(bundle.bundleId));
          if (tests.concat(bundles).some(test => !test.isSelect)) {
            highlight.isSelect = false;
          }
        });

      },
      // Family Bundle - Method disabled (UI hidden)
      // addFamilyMember() {
      //   this.$store.dispatch("orderTest/familyDiscount/setIsClickAddFamilyMember", true);
      //   this.showChooseFamilyMemberDialog = true;
      // },
      
  
    }
  }
  </script>
  
  <style scoped>
  .background-color {
    background-color: #f9fbfd;
  }
  .clear-all-btn, .clear-all-btn:hover {
    padding-bottom: 5px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    border: none;
    background: transparent;
    letter-spacing: 0.3432px;
    color: #DF4430;
  }
  
  .add_on_unfold_btn {
    color: #004879;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; 
  }
  .item-type-group-title {
    color: var(--DividerGray, #C4C4C4);
    font-family: Inter, sans-serif;
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    margin-top: 4px;
    margin-bottom: 4px;
  }
  </style>